import axios from 'axios';
import { getCacheItem } from './cacheManager';
import handleAxiosError from './handleAxiosError';
import store from './store';
import getUrl from './getUrl';
import resetStale from './resetStale';

const cancelTokens = {};

export default ({ props, cacheKey, options = {} }) => {
  const currentState = store.getState()[cacheKey];
  const currentCache = getCacheItem(cacheKey);

  if (currentCache.isFetching && cancelTokens[cacheKey]) {
    cancelTokens[cacheKey].cancel('Operation canceled due to new request.');
  }

  currentCache.isStale = false;
  currentCache.isFetching = true;

  store.dispatch({
    type: `${cacheKey}:STATUS`,
    payload:
      currentState.status === 'idle' || currentState.status === 'unresolved'
        ? 'loading'
        : 'syncing',
  });

  const { CancelToken } = axios;
  cancelTokens[cacheKey] = CancelToken.source();

  let fetchPromise;

  if (currentCache.isMocked) {
    fetchPromise = new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: currentCache.getMockedResponse({ cache: currentCache, props }),
        });
      }, 600);
    });
  } else {
    fetchPromise = axios({
      method: currentCache.method,
      url: getUrl({
        url: currentCache.url,
        params: currentCache.getParams({ props }),
      }),
      params: currentCache.query,
      cancelToken: cancelTokens[cacheKey].token,
    });
  }

  return fetchPromise
    .then((response) => {
      const { data } = response;

      resetStale({ cache: currentCache });

      const transformedData = currentCache.transform({ data, props });

      currentCache.isFetching = false;

      store.dispatch({
        type: `${cacheKey}:FETCHED`,
        payload: {
          data: transformedData,
          response: response.data,
        },
        options,
      });

      return currentCache;
    })
    .catch((error) => {
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message);
      } else {
        (currentCache.onError || handleAxiosError)(error);

        if (error.response) {
          const { data } = error.response;
          currentCache.isStale = true;
          currentCache.isFetching = false;
          store.dispatch({
            type: `${cacheKey}:ERRORED`,
            payload: {
              error: data,
              response: error.response,
            },
          });
          return;
        }
        console.error(error);
      }
    });
};
